/* ============================================================
 * Karl Kaplan – app-free collection filter (P1·08)
 * <kkb-collection-filter> builds filter pills from the products
 * in the collection (Alter / Größe / Art / Material) and shows/
 * hides grid items client-side. Collapsible: one "Filter" button
 * toggles a panel with all dimensions (like the sort dropdown).
 * No Search & Discovery required.
 * ============================================================ */
(function () {
  if (window.customElements.get('kkb-collection-filter')) return;

  var DIMS = [
    { key: 'alter', label: 'Alter', from: 'tag',
      order: ['baby', 'kids', 'erwachsene', 'alle'],
      labels: { baby: 'Baby', kids: 'Kids', erwachsene: 'Erwachsene', alle: 'Alle' } },
    { key: 'groesse', label: 'Größe', from: 'size' },
    { key: 'art', label: 'Art', from: 'tag',
      labels: { hoodie: 'Hoodie', sweatshirt: 'Sweatshirt', shirt: 'Shirt', body: 'Body',
                hose: 'Hose', set: 'Set', muetze: 'Mütze', tasche: 'Tasche' } },
    { key: 'material', label: 'Material', from: 'tag',
      labels: { 'bio-baumwolle': 'Bio-Baumwolle' } }
  ];

  function firstInt(s) { var m = String(s).match(/\d+/); return m ? parseInt(m[0], 10) : 9999; }

  // Buchstaben-Größen (Erwachsene) in fester Reihenfolge – nicht alphabetisch.
  var LETTER = { XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, XXXL: 7 };

  // Sizes are entered inconsistently across products
  // ("3-4/98-104cm" vs "3-4 (98-104cm)"). Normalise to the cm/month span
  // so the filter shows one clean pill per real size.
  function normSize(s) {
    s = String(s);
    var mo = s.match(/(\d+)\s*[-–]\s*(\d+)\s*(?:Monate|Monat|Months?|M)\b/i);
    if (mo) return mo[1] + '–' + mo[2] + ' Monate';
    var cm = s.match(/(\d+)\s*[-–]\s*(\d+)\s*cm/i);
    if (cm) return cm[1] + '–' + cm[2] + ' cm';
    return s.trim();
  }

  class KkbCollectionFilter extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      try {
        this.data = JSON.parse(this.querySelector('[data-kkb-filter-products]').textContent);
      } catch (e) { return; }
      this.grid = document.querySelector(this.getAttribute('data-grid') || '#product-grid');
      this.bar = this.querySelector('.kkb-cf__bar');
      this.countEl = this.querySelector('.kkb-cf__count');
      this.resetEl = this.querySelector('.kkb-cf__reset');
      this.toggleBtn = this.querySelector('.kkb-cf__toggle');
      this.panel = this.querySelector('.kkb-cf__panel');
      this.badge = this.querySelector('.kkb-cf__badge');
      this.doneBtn = this.querySelector('.kkb-cf__done');
      if (!this.grid || !this.bar) return;
      this.selected = {};
      DIMS.forEach(function (d) { this.selected[d.key] = []; }.bind(this));
      this.buildBar();
      if (this.resetEl) this.resetEl.addEventListener('click', this.reset.bind(this));
      if (this.toggleBtn) this.toggleBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (self.panel && self.panel.hidden) self.openPanel(); else self.closePanel();
      });
      if (this.doneBtn) this.doneBtn.addEventListener('click', this.closePanel.bind(this));
      document.addEventListener('click', function (e) {
        if (self.panel && !self.panel.hidden && !self.contains(e.target)) self.closePanel();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.panel && !self.panel.hidden) {
          self.closePanel();
          if (self.toggleBtn) self.toggleBtn.focus();
        }
      });
      this.apply();
    }

    openPanel() {
      if (this.panel) this.panel.hidden = false;
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'true');
    }

    closePanel() {
      if (this.panel) this.panel.hidden = true;
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'false');
    }

    valuesFor(handle, dim) {
      var rec = this.data[handle];
      if (!rec) return [];
      if (dim.from === 'size') {
        var seen = {}, out = [];
        (rec.groesse || []).forEach(function (v) {
          var n = normSize(v);
          if (!seen[n]) { seen[n] = 1; out.push(n); }
        });
        return out;
      }
      var pre = dim.key + ':';
      return (rec.tags || []).filter(function (t) { return t.indexOf(pre) === 0; })
        .map(function (t) { return t.slice(pre.length); });
    }

    buildBar() {
      var self = this;
      var handles = Object.keys(this.data);
      DIMS.forEach(function (dim) {
        var set = {};
        handles.forEach(function (h) {
          self.valuesFor(h, dim).forEach(function (v) { set[v] = true; });
        });
        var values = Object.keys(set);
        if (values.length < 2) return; // nothing to filter on

        if (dim.order) {
          values.sort(function (a, b) {
            var ia = dim.order.indexOf(a), ib = dim.order.indexOf(b);
            if (ia === -1) ia = 99; if (ib === -1) ib = 99;
            return ia - ib || a.localeCompare(b);
          });
        } else if (dim.key === 'groesse') {
          values.sort(function (a, b) {
            var la = LETTER[a.toUpperCase()], lb = LETTER[b.toUpperCase()];
            if (la && lb) return la - lb;   // beide Buchstaben-Größen: XS<S<M<L<XL
            if (la) return 1;               // Buchstaben ans Ende (nach Zahlengrößen)
            if (lb) return -1;
            // Zahlengrößen: erst 1. Zahl, dann 2. Zahl (6–9 vor 6–12), dann Text.
            var na = (String(a).match(/\d+/g) || []).map(Number);
            var nb = (String(b).match(/\d+/g) || []).map(Number);
            for (var i = 0; i < Math.max(na.length, nb.length); i++) {
              var x = na[i] == null ? 9999 : na[i];
              var y = nb[i] == null ? 9999 : nb[i];
              if (x !== y) return x - y;
            }
            return a.localeCompare(b);
          });
        } else {
          values.sort(function (a, b) { return self.label(dim, a).localeCompare(self.label(dim, b)); });
        }

        var group = document.createElement('div');
        group.className = 'kkb-cf__group';
        var lbl = document.createElement('p');
        lbl.className = 'kkb-cf__label';
        lbl.textContent = dim.label;
        group.appendChild(lbl);
        var pills = document.createElement('div');
        pills.className = 'kkb-cf__pills';
        values.forEach(function (v) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'kkb-cf__pill';
          b.setAttribute('aria-pressed', 'false');
          b.setAttribute('data-dim', dim.key);
          b.setAttribute('data-value', v);
          b.textContent = self.label(dim, v);
          b.addEventListener('click', function () { self.toggle(dim.key, v, b); });
          pills.appendChild(b);
        });
        group.appendChild(pills);
        self.bar.appendChild(group);
      });
    }

    label(dim, value) { return (dim.labels && dim.labels[value]) || value; }

    toggle(dimKey, value, btn) {
      var arr = this.selected[dimKey];
      var i = arr.indexOf(value);
      if (i === -1) { arr.push(value); btn.setAttribute('aria-pressed', 'true'); }
      else { arr.splice(i, 1); btn.setAttribute('aria-pressed', 'false'); }
      this.apply();
    }

    reset() {
      DIMS.forEach(function (d) { this.selected[d.key] = []; }.bind(this));
      this.bar.querySelectorAll('.kkb-cf__pill[aria-pressed="true"]')
        .forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      this.apply();
    }

    apply() {
      var self = this;
      var items = this.grid.querySelectorAll('.grid__item');
      var total = 0, visible = 0, active = false, count = 0;
      DIMS.forEach(function (d) {
        var n = self.selected[d.key].length;
        count += n;
        if (n) active = true;
      });

      items.forEach(function (item) {
        var a = item.querySelector('a[href*="/products/"]');
        if (!a) return;
        total++;
        var handle = a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
        var ok = DIMS.every(function (dim) {
          var sel = self.selected[dim.key];
          if (!sel.length) return true;
          var vals = self.valuesFor(handle, dim);
          return vals.some(function (v) { return sel.indexOf(v) !== -1; });
        });
        item.classList.toggle('kkb-cf-hidden', !ok);
        if (ok) visible++;
      });

      if (this.countEl) {
        this.countEl.textContent = active
          ? (visible + ' von ' + total + ' Produkten')
          : (total + ' Produkte');
      }
      if (this.resetEl) this.resetEl.hidden = !active;
      if (this.badge) { this.badge.textContent = String(count); this.badge.hidden = count === 0; }
    }
  }

  window.customElements.define('kkb-collection-filter', KkbCollectionFilter);
})();
